import React from 'react';

const staff = [
  {
    name: '岡山 太郎',
    position: '代表司法書士',
    experience: '司法書士歴25年',
    specialties: ['不動産登記', '商業登記', '相続手続き'],
    message: 'お客様一人ひとりに寄り添い、最適な解決策をご提案いたします。法的手続きでお困りの際は、お気軽にご相談ください。',
    image: 'https://public.readdy.ai/ai/img_res/997cde48c91bcea7b6e2b20778f496cd.jpg'
  },
  {
    name: '倉敷 花子',
    position: '司法書士',
    experience: '司法書士歴12年',
    specialties: ['相続手続き', '成年後見', '債務整理'],
    message: '相続や成年後見など、ご家族に関わる手続きを丁寧にサポートいたします。女性ならではの視点でお客様に寄り添います。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20female%20judicial%20scrivener%20age%2035%2C%20wearing%20elegant%20business%20suit%2C%20intelligent%20and%20warm%20smile%2C%20modern%20law%20office%20background%2C%20natural%20soft%20lighting%2C%20professional%20headshot%20portrait%2C%20trustworthy%20and%20friendly%20demeanor%2C%20sophisticated%20appearance&width=400&height=500&seq=staff-kurashiki-hanako-new-v3&orientation=portrait'
  },
  {
    name: '津山 次郎',
    position: '司法書士',
    experience: '司法書士歴8年',
    specialties: ['商業登記', '債務整理', '契約書作成'],
    message: '企業法務から個人の債務整理まで、幅広い分野でお客様をサポートいたします。迅速かつ正確な手続きを心がけています。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20young%20Japanese%20male%20judicial%20scrivener%20in%20his%20early%2030s%20wearing%20modern%20business%20suit%2C%20confident%20smile%2C%20energetic%20and%20reliable%20appearance%2C%20contemporary%20office%20environment%20with%20clean%20background%2C%20bright%20natural%20lighting%2C%20professional%20portrait%20photography%20style%2C%20no%20text%20or%20writing%20visible&width=300&height=400&seq=staff3new&orientation=portrait'
  }
];

export const Staff: React.FC = () => {
  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4">スタッフ紹介</h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            経験豊富な司法書士が、お客様の大切な手続きを責任を持ってサポートいたします。
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {staff.map((member, index) => (
            <div key={index} className="bg-gray-50 rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="h-64 md:h-80 overflow-hidden">
                <img 
                  src={member.image} 
                  alt={member.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">{member.name}</h3>
                <p className="text-blue-600 font-semibold mb-1 text-sm md:text-base">{member.position}</p>
                <p className="text-gray-600 mb-3 md:mb-4 text-sm md:text-base">{member.experience}</p>
                
                <div className="mb-3 md:mb-4">
                  <h4 className="text-xs md:text-sm font-semibold text-gray-900 mb-2">専門分野</h4>
                  <div className="flex flex-wrap gap-2">
                    {member.specialties.map((specialty, i) => (
                      <span key={i} className="px-2 md:px-3 py-1 bg-blue-100 text-blue-800 text-xs md:text-sm rounded-full whitespace-nowrap">
                        {specialty}
                      </span>
                    ))}
                  </div>
                </div>
                
                <p className="text-gray-600 text-xs md:text-sm leading-relaxed">{member.message}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
